import { useState, Fragment } from 'react';
import { Form, Button, Comment, Input } from 'antd';
import styled, { css } from 'styled-components';
import UserAvatar from 'components/UserAvatar';
import { useAuthContext } from 'utils/auth';

const { TextArea } = Input;

const AddCommentWrapper = styled.div`
  ${props =>
    props.columnLayout
      ? css`
          order: -1;
          flex: 0 0 50%;
          margin-right: 2rem;
        `
      : ''};
`;

function stopPropagation(e) {
  e.stopPropagation();
}

const Editor = ({ onChange, onSubmit, submitting, value }) => (
  <Fragment>
    <Form.Item>
      <TextArea
        data-testid="comment-text-input"
        id="comment-text-input"
        rows={2}
        onChange={onChange}
        onKeyDown={stopPropagation}
        onKeyUp={stopPropagation}
        value={value}
      />
    </Form.Item>

    <Form.Item>
      <Button
        id="add-comment-button"
        htmlType="submit"
        loading={submitting}
        onClick={onSubmit}
        disabled={!value.trim().length}
      >
        Add Comment
      </Button>
    </Form.Item>
  </Fragment>
);

export function AddComment({ onSave, columnLayout }) {
  const { user } = useAuthContext();
  const [newComment, setNewComment] = useState('');

  const handleSave = () => {
    onSave(newComment);
    setNewComment('');
  };

  return (
    <AddCommentWrapper columnLayout={columnLayout}>
      <Comment
        avatar={user && <UserAvatar user={user} />}
        content={
          <Editor
            onChange={e => setNewComment(e.target.value)}
            onSubmit={handleSave}
            value={newComment}
          />
        }
      />
    </AddCommentWrapper>
  );
}
